const normalizePhone = value => String(value || "").replace(/\D/g, "");

const getConnectionById = (whatsApps, whatsappId) =>
  (whatsApps || []).find(connection => connection?.id === whatsappId);

const getConnectionByPhone = (whatsApps, phone) => {
  const normalizedPhone = normalizePhone(phone);
  return (whatsApps || []).find(
    connection => normalizePhone(connection?.phoneNumber) === normalizedPhone
  );
};

export const getInternalConversationInfo = (ticket, whatsApps) => {
  const ownConnection = getConnectionById(whatsApps, ticket?.whatsappId);
  const otherConnection = getConnectionByPhone(
    whatsApps,
    ticket?.contact?.number
  );

  if (
    !ownConnection ||
    !otherConnection ||
    ownConnection.id === otherConnection.id
  ) {
    return null;
  }

  const connectionIds = [ownConnection.id, otherConnection.id].sort(
    (a, b) => a - b
  );
  const names = [ownConnection.name, otherConnection.name]
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b));

  return {
    key: connectionIds.join(":"),
    label: names.join(" ↔ "),
    ownConnection,
    otherConnection,
  };
};

export const groupInternalTickets = (tickets, whatsApps) => {
  const groups = new Map();
  const output = [];

  (tickets || []).forEach(ticket => {
    const internalInfo = getInternalConversationInfo(ticket, whatsApps);
    if (!internalInfo) {
      output.push(ticket);
      return;
    }

    const existing = groups.get(internalInfo.key);
    if (!existing) {
      const groupedTicket = {
        ...ticket,
        internalConversationKey: internalInfo.key,
        internalConversationLabel: internalInfo.label,
        internalTickets: [ticket],
        internalConnections: [
          internalInfo.ownConnection,
          internalInfo.otherConnection,
        ],
      };
      groups.set(internalInfo.key, groupedTicket);
      output.push(groupedTicket);
      return;
    }

    existing.internalTickets.push(ticket);
    existing.unreadMessages = Math.max(
      existing.unreadMessages || 0,
      ticket.unreadMessages || 0
    );

    if (new Date(ticket.updatedAt) > new Date(existing.updatedAt)) {
      existing.updatedAt = ticket.updatedAt;
      existing.lastMessage = ticket.lastMessage;
      existing.lastMessageFromMe = ticket.lastMessageFromMe;
      existing._pendingLastMessageStatus = ticket._pendingLastMessageStatus;
    }

    if (
      (ticket.unreadMessages || 0) > 0 &&
      (existing.internalTickets[0]?.unreadMessages || 0) === 0
    ) {
      existing.id = ticket.id;
      existing.contact = ticket.contact;
      existing.contactId = ticket.contactId;
      existing.whatsapp = ticket.whatsapp;
      existing.whatsappId = ticket.whatsappId;
    }
  });

  return output;
};

export { normalizePhone };
